export default __webpack_public_path__ + "static/media/empty-card.b9ae02e8.png";